import React from "react";

import { Link } from "react-router-dom";

function Ai() {
  return (
    <div>
      <section
        className="page-title"
        style={{
          backgroundImage: "url(../images/background/bg-page-title-1.jpg)",
        }}
      >
        <div className="auto-container">
          <h1>AI&BIG DATA</h1>
          <div className="bread-crumb-outer">
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="active">AI 관제 서비스</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="feature-style-1">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 company">
              <div className="company-tab">
                <ul className="nav nav-pills nav-justified">
                  <li className="active">
                    <Link data-toggle="pill" to="/ai">
                      AI 관제 서비스{" "}
                    </Link>
                  </li>
                  <li>
                    <Link data-toggle="pill" to="/bigdata">
                      빅데이터 플랫폼{" "}
                    </Link>
                  </li>
                  <li>
                    <Link data-toggle="pill" to="/fusion">
                      빅데이터 융합 서비스{"  "}
                    </Link>
                  </li>
                  {/* <li>
                    <Link data-toggle="pill" to="/tmap">
                      T-map API{"  "}
                    </Link>
                  </li> */}
                </ul>
                <div className="tab-content">


                <div className='tab_content_area'>
                                <div className="tab_title" style={{width:'106%'}}>
                                    AI 시각 지능화 기반 실시간 관제 서비스
                                </div>
                                <div className='tab_paragraph'>
                                    <p>개요</p>
                                    <div className='tab_brackets'></div>
                                        <ul>
                                            <li>- AI기반 실시간 사람, 사물 인식으로 사람의 행동을 이해하는 시각 지능 핵심 솔루션</li>
                                            <li>- CCTV, 카메라 등에서 수집한 이미지 데이터를 사전 학습된 AI가 객체로 검출</li>
                                            <li>- 검출된 데이터로부터 사람의 행동을 분석하는 실시간 관제 모니터링 S/W 제공</li>
                                        </ul>
                                    <div>
                                        <div className='servicePostBox1'>
                                            <div className='servicePostCard1'>
                                                <p className='cardname'>1.실세계 데이터</p>
                                                <div>
                                                    <p>· CCTV, 카메라, 드론 짐벌 등에서 이미지 데이터 수집</p>
                                                    </div>
                                                    <img src='./images/service/Ai/image2.png' alt=''/>
                                            </div>
                                                <img className='arrowS1' src='./images/service/Ai/arrow2.png' alt=''/>
                                            <div className='servicePostCard1'>
                                                <p className='cardname'>2.AI 기반 영상처리</p>
                                                <div>
                                                 <p >· 사람, 사물을 사전학습하여 이미지와 영상 속 객체 인식</p>
                                                </div>
                                                    <img className='postCardimg2' src='./images/service/Ai/image3.png' alt=''/>
                                            </div>
                                                    <img className='arrowS1' src='./images/service/Ai/arrow2.png' alt=''/>
                                            <div className='servicePostCard1'>
                                                <p className='cardname'>3.실시간 관제</p>
                                                <div>
                                                  <p>· 검출된 객체 및 사람의 행동을 이해하여 실시간 감지</p>
                                                </div>
                                                <img src='./images/service/Ai/image4.png' alt=''/>
                                                <img src='./images/service/Ai/image5.png' alt=''/>
                                            </div>
                                        </div>
                                    </div>
                                </div><br/>
                                <div className='tab_paragraph'>
                                    <p>특장점</p>
                                    <div className='tab_brackets'></div>
                                        <ul>
                                            <li>- 영상 내 사물 검출 대상 추가를 통해 적용 가능 분야 확장 가능</li>
                                            <li>- 기존 운영중인 CCTV 활용으로 구축 비용 절감</li>
                                            <li>- 불법 쓰레기 투기, 위급상황자, 분실물, 위험물 등 공공 질서 및 사회 안전 분야 적용 가능</li>
                                        </ul>
                                    <div  className='servicePostBox1'>
                                        <img src='./images/service/Ai/image10.png' alt=''/>
                                    </div>
                                </div>
                                <div className='tab_paragraph'>
                                    <p>적용 사례</p>
                                    <div className='tab_brackets'></div>
                                        <ul>
                                            <li>- 세종시, 서울시 은평구, 대전시 유성구 등 쓰레기 무단투기 단속 및 대전광역시 이상징후 실증 적용</li>
                                        </ul>
                                    <div className='servicePostBox1'>
                                        <div style={{maxWidth:'400px', marginTop:'30px'}}>
                                            <ul>
                                                <li><img src='./images/service/Ai/image6.png' alt=''style={{width:'87%', marginBottom:'5px'}}/></li>
                                                <li><div style={{display:'flex', justifyContent:'center'}}>
                                                    <img src='./images/service/Ai/image7.png' alt=''style={{width:'40%'}}/>
                                                    <img src='./images/service/Ai/image8.png' alt=''style={{width:'43%', marginLeft:'4%'}}/>
                                                </div></li>
                                                <li style={{textAlign:'center',color:'black'}}><b>입력 영상(CCTV)</b></li>
                                            </ul>    
                                        </div>
                                        <div className='arrowS2'>
                                            관계모델링 기반<br/>
                                            이상행동 검출<br/><br/>
                                            <img src='./images/service/Ai/arrow1.png' alt=''/>
                                        </div>
                                            <img className='aiPostImg1' src='./images/service/Ai/image9.png' alt=''/>
                                            <b className='aiPostb1'>쓰레기 투기 탐지 결과</b>
                                            <b className='aiPostb2'>투기 탐지 경고 방송</b>
                                    </div>
                                </div>
                            </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Ai;
